import Grid from "@mui/material/Grid";
import AppButton from "../../../../components/ui/AppButton";

interface TransportRowAction2ButtonsProps {
  firstButtonLabel: string;
  firstButtonHandle: any;
  secondButtonLabel: string;
  secondButtonHandle: any;
  isFirstButtonActive: boolean;
  fontSize?: string;
}

/**
 * Shared two-button toggle used by rail/transport booking rows (class, direction, etc.).
 */
export default function TransportRowAction2Buttons({
  firstButtonLabel,
  firstButtonHandle,
  secondButtonLabel,
  secondButtonHandle,
  isFirstButtonActive,
  fontSize = "13px"
}: TransportRowAction2ButtonsProps) {
  return (
    <Grid
      item
      className="transport-row-action-2-buttons"
      sx={{ display: "flex", flexDirection: "row", flex: 1, alignItems: "stretch", justifyContent: "center" }}
    >
      <Grid item className="transport-row-action-2-buttons__btn" width={{ xs: 100, sm: 100, md: 120 }}>
        <AppButton
          label={firstButtonLabel}
          onClick={firstButtonHandle}
          disableRipple={true}
          customBackgroundColor={isFirstButtonActive ? "#3c3c3c" : "#cdcdcd"}
          customHoverColor={isFirstButtonActive ? "#3c3c3c" : "#cdcdcd"}
          labelColor={isFirstButtonActive ? "#ffffff" : "#3c3c3c"}
          type="submit"
          fontSize={fontSize}
        />
      </Grid>
      <Grid item width={"4%"} />
      <Grid item className="transport-row-action-2-buttons__btn" width={{ xs: 100, sm: 100, md: 120 }}>
        <AppButton
          label={secondButtonLabel}
          onClick={secondButtonHandle}
          disableRipple={true}
          customBackgroundColor={!isFirstButtonActive ? "#3c3c3c" : "#cdcdcd"}
          customHoverColor={!isFirstButtonActive ? "#3c3c3c" : "#cdcdcd"}
          labelColor={!isFirstButtonActive ? "#ffffff" : "#3c3c3c"}
          type="submit"
          fontSize={fontSize}
        />
      </Grid>
    </Grid>
  );
}
